export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13773.d94aec3d.jpg";